// main.ts or similar
import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faHome,
  faSearch,
  faUser,
  faBan,
  faSquareCheck,
  faSquare,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faXmark,
  faQuestion,
  faArrowRightFromBracket,
  faBell,
  faCircleInfo,
} from "@awesome.me/kit-5a1649bb4c/icons/classic/solid";

import { faSquare as farSquare } from "@awesome.me/kit-5a1649bb4c/icons/classic/regular";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import type { App } from "vue";

// Specify the icons you want to use
export const icons = {
  faUser: faUser,
  faHome: faHome,
  faSearch: faSearch,
  faBan: faBan,
  faSquareCheck: faSquareCheck,
  faSquare: faSquare,
  farSquare: farSquare,
  faChevronRight: faChevronRight,
  faChevronDown: faChevronDown,
  faChevronUp: faChevronUp,
  faXmark: faXmark,
  faQuestion: faQuestion,
  faArrowRightFromBracket: faArrowRightFromBracket,
  faBell: faBell,
  faCircleInfo: faCircleInfo,
};

const addIconsToLibrary = () => {
  Object.values(icons).forEach((icon) => {
    library.add(icon);
  });
};

const registerComponent = (app: App) => {
  app.component("font-awesome-icon", FontAwesomeIcon);
};

export type IconName = keyof typeof icons;

const SVFontAwesome = {
  install: (app: App) => {
    addIconsToLibrary();
    registerComponent(app);
  },
};

export default SVFontAwesome;
